import { useContext, useState } from 'react';
import { Avatar, IconButton, Menu, MenuItem, TableCell, TableRow, Tooltip, Box, Divider } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
// Our Components
import { BUSINESSES_ACTIONS } from 'context/businesses/businessReducer';
import { BusinessContext } from 'context/businesses/businessContext';
// Utils and Helpers
import { BUSINESS_FUNDING_TYPE } from 'helpers/constants';
import { formatPhoneNumber } from 'helpers';
import { numberFormat } from 'helpers/i18n';
import setHttp from 'helpers/setHttp';
// Assets
import './BusinessTableRow.css';

const { SET_BUSINESS, SHOW_APPROVAL_MODAL, SHOW_REJECT_MODAL } = BUSINESSES_ACTIONS;
dayjs.extend(utc);

const PREFUNDING_TYPES_MAP = {
    [BUSINESS_FUNDING_TYPE.CREDIT_LINE]: 'Paystand',
    [BUSINESS_FUNDING_TYPE.PREFUNDING]: 'Wire'
};

const BusinessTableRow = ({ row: business }) => {
    const { dispatch } = useContext(BusinessContext);
    const [isBusinessMenuOpen, setIsBusinessMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleActionsMenuClick = event => {
        setIsBusinessMenuOpen(true);
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionsMenu = () => {
        setIsBusinessMenuOpen(false);
        setAnchorEl(null);
    };

    const handleApproveActionClick = async () => {
        setIsBusinessMenuOpen(false);
        setAnchorEl(null);
        dispatch({ type: SET_BUSINESS, payload: business });
        dispatch({ type: SHOW_APPROVAL_MODAL });
    };

    const handleRejectActionClick = async () => {
        setIsBusinessMenuOpen(false);
        setAnchorEl(null);
        dispatch({ type: SET_BUSINESS, payload: business });
        dispatch({ type: SHOW_REJECT_MODAL });
    };

    return (
        <TableRow>
            <TableCell className="table-row-cell">
                <Box className="fw-bold" sx={{ marginBottom: '5px' }}>
                    {`${business.first_name} ${business.last_name}`}
                </Box>
                <Box className="gray-text">{business.email}</Box>
            </TableCell>
            <TableCell className="table-row-cell">{PREFUNDING_TYPES_MAP[business.funding_type] || 'N/A'}</TableCell>
            <TableCell className="table-row-cell">{formatPhoneNumber(business.phone_number) || 'N/A'}</TableCell>
            <TableCell className="table-row-cell">
                <Box className="fw-bold" sx={{ marginBottom: '5px' }}>
                    {business.legal_name}
                </Box>
                <Box className="gray-text">{business.source}</Box>
            </TableCell>
            <TableCell className="table-row-cell">
                <Box className="fw-bold" sx={{ marginBottom: '5px' }}>
                    {business.bank_name}
                </Box>
                <Box className="gray-text">{business.account_type}</Box>
            </TableCell>
            <TableCell className="table-row-cell">
                <Box className="fw-bold" sx={{ marginBottom: '5px' }}>
                    {dayjs(business.created_at).utc().format('YYYY-MM-DD')}
                </Box>
                <Box className="gray-text">{`${dayjs(business.created_at).utc().format('HH:MM:ssa')} UTC`}</Box>
            </TableCell>
            <TableCell className="table-row-cell">
                <Box className="fw-bold">{numberFormat(business.balance)}</Box>
            </TableCell>
            <TableCell className="table-row-cell">
                <a target="_blank" rel="noreferrer" href={setHttp(business.website_url)} title={business.website_url}>
                    {business.website_url}
                </a>
            </TableCell>
            <TableCell>
                <Tooltip title="Applicant settings" placement="top">
                    <IconButton data-testid="actions-menu" size="small" sx={{ marginLeft: 2 }} onClick={handleActionsMenuClick}>
                        <Avatar className="action-menu-btn">
                            <MoreVert />
                        </Avatar>
                    </IconButton>
                </Tooltip>
            </TableCell>
            <Menu anchorEl={anchorEl} open={isBusinessMenuOpen} onClose={handleCloseActionsMenu}>
                <MenuItem onClick={handleApproveActionClick}>Approve</MenuItem>
                <Divider />
                <MenuItem onClick={handleRejectActionClick}>Reject</MenuItem>
            </Menu>
        </TableRow>
    );
};

export default BusinessTableRow;
